import { StyledLogoBox, StyledLogo } from './Logo.styles';
import Terre54Logo from '../../../assets/pictures/Terre54Logo.png';

export interface LogoProps {
  height: number;
  width: number;
}

const Logo = ({ height, width }: LogoProps) => {
  return (
    <StyledLogoBox height={height} width={width}>
      <StyledLogo src={Terre54Logo} alt="Learner Labs Logo" />
    </StyledLogoBox>
  );
};

export default Logo;
